import { Notification } from 'element-ui'
export const doubleClickToCopyText = async copyText => {
  try {
    if (copyText.length > 1) {
      copyText = copyText.indexOf('№') > -1 ? copyText.slice(1) : copyText
      await navigator.clipboard.writeText(copyText)
      Notification({
        title: 'Скопирован номер контракта',
        message: copyText,
        type: 'success',
        customClass: 'notificator_text',
      })
    }
  } catch (e) {
    Notification.error({
      title: `Ошибка ${e}`,
      message: 'Текст не скопирован',
    })
  }
}
